import * as angular from "angular";

import { StateService } from '@uirouter/angularjs';
import { IComponentOptions } from 'angular';
import "./sidenav.less";

import { OS_EVENTS_LOGS_STATE } from '../../logs/logs.router';
import { EMAIL_CONFIRMED_STATE } from '../../email-confirmed/email-confirmed.router';
import { DASHBOARD_STATE } from '../../dashboard/dashboard.router';
import { SHARED_STORAGE_STATE } from "../../shared-storage/shared-storage.router";
import { DATA_DIRECT_STATE } from "../../data-direct/data-direct.router";
import { SCHEDULER_STATE } from "../../scheduler/scheduler.router";
import { BACKUP_AND_RESTORE_STATE } from "../../backup-and-restore/backup-and-restore.router";
import { BENGLOGS_STATE } from "../../beng-logs/beng-logs.router";
import { USERS_STATE } from "../../users/users.router";
import { CAPSULE_STATE } from "../../capsule/capsule.router";

import { IInstanceSettings, IInstanceSettingsDto } from "../../../typings/board/Models";
import { InstanceSettingsService, INSTANCE_SETTINGS_SERVICE } from "../../instance-settings/instance-settings.service";

export const SIDENAV_ID = "mainSidenav";

class SidenavComponentController {

    static $inject = ["$mdSidenav", "$state", INSTANCE_SETTINGS_SERVICE, "IDP_ENDPOINT"];
    constructor(private $mdSidenav: ng.material.ISidenavService,
        private $state: StateService, private instanceSettingService: InstanceSettingsService, private readonly idpEndpoint: string) { }

    private links = [];

    private navigate(state: string) {
        this.$state.go(state)
            .then(() => {
                this.$mdSidenav(SIDENAV_ID, true);
            });
    }

    $onInit() {
        this.instanceSettingService.getSettings().then(settings => {
            if (settings) {
                this.links = [
                    { title: "Services status", description: "Show CPU and RAM usage", icon: "admin:status", state: DASHBOARD_STATE },
                    { title: "Scheduler", description: "Tasks scheduler", icon: "admin:reload", state: SCHEDULER_STATE },
                    { title: "Database Backup restore", description: "Backup and restore", icon: "admin:backup", state: BACKUP_AND_RESTORE_STATE },
                    { title: "Capsules organizer", description: "Upload, download and move", icon: "admin:capsule", state: CAPSULE_STATE },
                    { title: "OS Events", description: "Operating System events log", icon: "admin:events", state: OS_EVENTS_LOGS_STATE },
                    { title: "Shared Storage", description: "Files Exchange Service", icon: "admin:storage", state: SHARED_STORAGE_STATE },
                    { title: "Logs", description: "Board Logs ", icon: "admin:logs", state: BENGLOGS_STATE }
                ];
            }
            if (settings.dataDirectEnabled) {
                this.links = [
                    { title: "Services status", description: "Show CPU and RAM usage", icon: "admin:status", state: DASHBOARD_STATE },
                    { title: "Scheduler", description: "Schedule a Board procedure", icon: "admin:reload", state: SCHEDULER_STATE },
                    { title: "Database Backup restore", description: "Backup and restore", icon: "admin:backup", state: BACKUP_AND_RESTORE_STATE },
                    { title: "Capsules organizer", description: "Upload, download and move", icon: "admin:capsule", state: CAPSULE_STATE },
                    { title: "Data Pipeline", description: "Cloud Connectors", icon: "admin:datasources", state: DATA_DIRECT_STATE },
                    { title: "Shared Storage", description: "Files Exchange Service", icon: "admin:storage", state: SHARED_STORAGE_STATE },
                    { title: "Logs", description: "Board Logs ", icon: "admin:logs", state: BENGLOGS_STATE },
                    { title: "OS Events", description: "Operating System events log", icon: "admin:events", state: OS_EVENTS_LOGS_STATE }                    
                ];
            }
            //this.links.push({ title: "Data Pipeline", description: "Cloud Connectors", icon: "admin:datasources", state: DATA_DIRECT_STATE });

            if (!this.idpEndpoint) {
                this.links.push({ title: "Users", description: "Manage portal users", icon: "admin:users", state: USERS_STATE });
            }
        });
    }
}

export const sidenavComponent: IComponentOptions = {
    controller: SidenavComponentController,
    template: require("./sidenav.html")
};



// WEBPACK FOOTER //
// ./app/layout/sidenav/sidenav.component.ts